import type { TabOption } from '@/components/chariot-ui';
import type {
  MainTabKey,
  POEContent,
  SectionContent,
} from '@/sections/poe/types/poe.types';

export function processWhoisDataSource(
  poeData: POEContent,
  sections: Record<string, SectionContent>,
  tempTabs: Record<MainTabKey, TabOption[]>,
  mainTabKeys: MainTabKey[]
) {
  if (!poeData) return;
  // The Whois record is the raw string in poeData
  const whois = typeof poeData === 'string' ? poeData : '';

  sections['whois_record'] = (
    <pre className="text-chariot-text-primary m-0 max-h-96 cursor-pointer overflow-auto border-0 bg-transparent p-0 font-mono text-sm whitespace-pre-wrap">
      {whois}
    </pre>
  );

  if (mainTabKeys.includes('INFORMATION')) {
    tempTabs['INFORMATION'].push({
      label: 'Whois Record',
      value: 'whois_record',
    });
  }
}
